<template>
  <v-container v-if="renderizacaoLiberada" fluid>
    <validation-observer ref="validationObserver" v-slot="{ valid }">
      <v-row>
        <v-col md="6" cols="12">
          <primeira-tab ref="refPrimeiraTab" :relatorio="relatorio">
            <template v-slot:footer>
              <v-btn
                id="btn-save-relatorio-modelo"
                color="primary"
                style="float: right"
                class="mr-0"
                :disabled="!valid"
                :loading="loading"
                @click="salvar()"
              >
                Salvar
              </v-btn>
            </template>
          </primeira-tab>
        </v-col>
        <v-col md="6" cols="12">
          <segunda-tab
            ref="refSegundaTab"
            :relatorio="relatorio"
            @reset:error-messages="$refs.validationObserver.reset()"
            @change-parametros:adicionado="$refs.refPrimeiraTab.adicionarParametroSQL($event)"
            @change-parametros:removido="$refs.refPrimeiraTab.removerParametroSQL($event)"
          />
        </v-col>
      </v-row>
    </validation-observer>
  </v-container>
</template>

<script>
  import RelatoriosModelosService from '@/services/RelatoriosModelosService';
  import routes from '@/store/modules/routes';

  export default {
    components: {
      PrimeiraTab: () => import('@/components/power-ups/relatorios-modelos/PrimeiraTab'),
      SegundaTab: () => import('@/components/power-ups/relatorios-modelos/SegundaTab')
    },

    data: () => ({
      loading: false,
      relatorio: {}
    }),

    computed: {
      renderizacaoLiberada() {
        if (!this.$route.params.id) return true;

        return this.$route.params.id && JSON.stringify(this.relatorio) !== '{}' ? true : false;
      }
    },

    created() {
      if (this.$route.params.id) this.getRelatorioModelo(this.$route.params.id);
    },

    methods: {
      getRelatorioModelo(id) {
        RelatoriosModelosService.getRelatorioModelo(id)
          .then((response) => {
            let rData = response.data.data;
            this.relatorio = {
              nome: rData.nome,
              grupoId: rData.grupo_relatorio.id,
              consultaSQL: rData.codigo_sql,
              descricao: rData.descricao ? rData.descricao : '',
              parametros_editaveis: rData.parametros_editaveis,
              exclusivo: rData.exclusivo ? 'Sim' : 'Não'
            };
          })
          .catch(() =>
            this.$toast.error('Erro ao recuperar relatorio modelo.', '', {
              position: 'topRight'
            })
          );
      },

      salvar() {
        let data = { id: this.$route.params.id ? this.$route.params.id : null };
        data = {
          ...data,
          ...this.$refs.refPrimeiraTab.exportCampos(),
          ...this.$refs.refSegundaTab.exportCampos()
        };

        (data.id = this.$route.params.id ? this.$route.params.id : null), (this.loading = true);

        RelatoriosModelosService.save(data)
          .then(() => {
            this.$toast.success('Relatório modelo salvo com sucesso.', '', {
              position: 'topRight'
            });
            this.$router.replace({
              name: routes.state.appRoutes['RELATORIOS_MODELOS_HISTORICO']
            });
          })
          .catch(() => {
            this.$toast.error('Erro ao salvar relatório modelo.', '', {
              position: 'topRight'
            });
          })
          .finally(() => (this.loading = false));
      }
    }
  };
</script>
